import type { CloudResourceHierarchyPathItem } from '@ipfabric/utils/types/CloudResourceHierarchyPathItem';
import type { ApiRequestParams } from 'utils/request/ApiRequestParams';
import type { CloudConstructKind } from '../helpers/cloudConstruct';

export interface CloudResourceHierarchyPathRequestBody {
  snapshot: string;
  kind: CloudConstructKind;
  id: string;
}

interface RequestParams {
  kind: CloudConstructKind;
  id: string;
  snapshotId: string;
}

export const getCloudResourceHierarchyPathRequestPayload = ({
  kind,
  id,
  snapshotId,
}: RequestParams): ApiRequestParams<CloudResourceHierarchyPathRequestBody> => ({
  url: '/cloud/resource-hierarchy',
  method: 'POST',
  data: { snapshot: snapshotId, kind, id },
});

export type CloudResourceHierarchyPathResponse =
  CloudResourceHierarchyPathItem[];
